import React, { useContext, useEffect, useState } from 'react'
import Layout from '../../../product/components/templates/Layout'
import PrimaryButton from '../../../product/components/atoms/PrimaryButton'
import SecondaryButton from '../../../product/components/atoms/SecondaryButton'
import GitlabContext from '../../../product/context/thirdParty/gitlab/gitlabContext'
import CustomTable from '../../../product/components/molecules/CustomTable'
import { useFormik } from 'formik'

const AutomationTesting = (props) => {
    const gitlabContext = useContext(GitlabContext)

    const [tableBody, setTableBody] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const {
        gitlabAction,
        getGitlabStatus,
        gitlab_status,
        responseStatus,
        clearResponse,
    } = gitlabContext

    const formik = useFormik({
        initialValues: {
            searchterm: '',
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            project_name: 'chicagowine_automation',
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getGitlabStatus(values)
        },
    })

    const handleSubmit = () => {
        setIsLoading(true)
        gitlabAction(
            {
                project_name: 'chicagowine_automation',
                user_id: 1,
            },
            'GITLAB_TRIGGER_ACTION'
        )
    }

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.page = 1
        formik.values.searchterm = ''
        getGitlabStatus(formik.values)
    }, [])

    const tableValues = [
        {
            field: 'project_name',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Project Name',
        },
        {
            field: 'pipeline_id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Pipeline Id',
        },
        {
            field: 'status',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Status',
        },
        {
            field: 'triggered_at',
            type: 'datetime',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Triggered Time',
        },
    ]

    useEffect(() => {
        if (gitlab_status) {
            setTableBody(
                gitlab_status.records.length ? gitlab_status.records : []
            )
        }
        setIsLoading(false)
    }, [gitlab_status])

    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'GITLAB_TRIGGER_ACTION') {
                getGitlabStatus(formik.values)
            }
            clearResponse()
        }
        setIsLoading(false)
    }, [responseStatus])

    return (
        <Layout>
            <div className="dashboard staticPages">
                <div className="miscActions d-flex justify-content-between align-items-center mt-4">
                    <PrimaryButton
                        id="automation_trigger_btn"
                        onClick={handleSubmit}
                        label="Run Automation"
                    />
                    <SecondaryButton
                        id="automation_fetch_btn"
                        onClick={formik.handleSubmit}
                        label="sync"
                        iconLeft={
                            <span className="material-icons">sync_icon</span>
                        }
                    />
                </div>
                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={[]}
                    allData={gitlab_status}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={getGitlabStatus}
                />
            </div>
        </Layout>
    )
}

export default AutomationTesting
